import React from 'react';
import { GridToolbarContainer } from '@mui/x-data-grid';
import DataGridColumnReorderButton from '@/components/table/DataGridComponents/DataGridColumnReorderButton';

// Toolbar slot for grids whose only toolbar control is the Columns button
const DataGridColumnReorderToolbar = () => (
	<GridToolbarContainer sx={{ px: 1 }}>
		<DataGridColumnReorderButton />
	</GridToolbarContainer>
);

export default DataGridColumnReorderToolbar;
